import styled, { css } from 'styled-components/native';

import Image from '../../../elements/Image';
import FlatListWithImpression from '../../FlatListWithImpression';

const textCSS = css`
  color: ${({ theme }) => theme.palette.warrior};
  font-size: 15px;
  line-height: 21px;
`;

export const LIST_CONTAINER_PADDING = 10;

export const S = {
  EmptyLayout: styled.View`
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.palette.neutralWhite};
    padding: 60px 0 40px;
  `,
  EmptyResultImage: styled(Image)`
    width: 70px;
    height: 70px;
  `,
  EmptyResultTitle: styled.Text`
    margin: 15px;
    margin-bottom: 10px;
    font-weight: 700;
    ${textCSS};
  `,
  EmptyResultSubtitle: styled.Text`
    color: ${({ theme }) => theme.palette.neutralDark};
    font-size: 12px;
  `,
  SubtitleContainer: styled.View`
    display: flex;
    flex-direction: row;
    align-items: center;
  `,
  SearchNotFoundSubTitleContainer: styled.View`
    align-items: center;
    flex-direction: row;
  `,
  SearchNotFoundSubTitle: styled.Text`
    color: ${({ theme }) => theme.palette.neutralDark};
    font-size: 12px;
  `,
  Subtitle: styled.Text`
    color: ${({ theme }) => theme.palette.neutralDark};
    font-size: 12px;
    margin-left: 4;
  `,
  ListTitleField: styled.View`
    flex-direction: row;
    align-items: center;
    background-color: ${({ theme }) => theme.palette.white};
    padding: 13px 15px 5px;
  `,
  ListTitle: styled.Text`
    margin-left: 8px;
    font-weight: 700;
    ${textCSS};
  `,
  List: styled(FlatListWithImpression)`
    background-color: ${({ theme }) => theme.palette.white};
  `,
};
